import { ClaimRequest, ClaimsControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claim: ClaimRequest;
}

export const useAddElectronicClaim = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimsControllerApi(getConfigObject()).createClaim(
      params.claim,
      getXtenantId()
    )
  );
